import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fallbacktext"];

  connect() {
    try {
      const params = new URLSearchParams(window.location.search);
      const hotelId = this.element.dataset.hotelId;
      const checkIn = params.get("checkin");
      const checkOut = params.get("checkout");
      const adults = parseInt(params.get("adults") || "1");
      const rooms = parseInt(params.get("rooms") || "1");

      // Get all child_age parameters
      const childAges = [];
      for (let i = 0; i < 10; i++) {
        // max 10 children
        const age = parseInt(params.get(`child_age[${i}]`));
        if (!isNaN(age)) {
          childAges.push(age);
        }
      }

      if (!hotelId || !checkIn || !checkOut) {
        console.warn(
          "Missing required parameters: hotel_id, checkin, or checkout"
        );
        return;
      }

      this.loadBenefits(hotelId, checkIn, checkOut, adults, rooms, childAges);
    } catch (error) {
      console.error("Error in benefit controller:", error);
    }
  }

  async loadBenefits(
    hotelId,
    checkIn,
    checkOut,
    adults = 1,
    rooms = 1,
    childrenAges = []
  ) {
    try {
      const params = {
        hotel_id: hotelId,
        checkin: checkIn,
        checkout: checkOut,
        adults: adults,
        rooms: rooms,
        child_age: childrenAges,
      };

      const response = await fetch(`/api/v1/hotels/benefits`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (Array.isArray(data) && data[0].rooms.length > 0) {
        this.renderBenefits(data[0].rooms);
      }
      this.updatePrices(data);
    } catch (error) {
      console.error("Error loading benefits:", error);
      // Consider adding a UI notification here
    }
  }

  updatePrices(data) {
    const hotelPrice = document.getElementById("hotel-price");
    if (hotelPrice) {
      hotelPrice.textContent = data[0].per_night_with_currency;
      hotelPrice.dataset.originalPrice = data[0].per_night;
    }
    data[0].rooms.forEach((room) => {
      const roomContainer = this.element.querySelector(`[data-room-id="${room.room_id}"]`);
      if (!roomContainer) {
        return;
      }
  
      // Update ALL elements with data-original-price
      const originalPriceElements = roomContainer.querySelectorAll('[data-original-price]');
      originalPriceElements.forEach((el) => {
        el.textContent = room.per_night;
        el.dataset.originalPrice = room.original_price;
      });
    });
    const event = new CustomEvent("currency:convert");

    window.dispatchEvent(event);
  }

  renderBenefits(rooms) {
    rooms.forEach((room) => {
        const roomContainer = this.element.querySelector(`[data-room-id="${room.room_id}"]`);
        if(!roomContainer || Object.keys(room.benifits).length == 0) {
          return
        }

        const fallbackText = roomContainer.querySelector(`[data-benifit-section="fallbacktext"]`);
        if (fallbackText) {
          fallbackText.classList.add("hidden");
        }

        Object.entries(room.benifits).forEach(([type, benefit]) => {
          const benefitType = roomContainer.querySelector(`[data-benifits-type="${type}"]`);
          if (benefitType && benefit) {
            benefitType.classList.remove("hidden");
            const benefitText = benefitType.querySelector(".type-text");
            if (benefitText) {
              benefitText.innerHTML = benefit;
            }
          }
        });
    });
  }
}
